export function deepOmitTypename<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map((item) => deepOmitTypename(item)) as any;
  } else if (obj !== null && typeof obj === "object") {
    const newObj: any = {};
    Object.keys(obj).forEach((key) => {
      if (key !== "__typename") {
        newObj[key] = deepOmitTypename((obj as any)[key]);
      }
    });
    return newObj;
  }
  return obj;
}

export default deepOmitTypename;
